import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdiurbania() {

const cardData = {
keyword: "Pune to Shirdi Urbania On Rent",
headingDescription: "Pune to Shirdi Urbania On Rent is a convenient group travel option for Sai Baba Darshan, family pilgrimages, weekend visits, and planned religious tours. Ruturaj Enterprises provides comfortable Urbania vehicles in multiple seating capacities for Pune to Shirdi journeys, with spacious interiors, experienced drivers, flexible trip planning, and options for one-way or round-trip travel. Whether you are travelling with family, friends, senior citizens, or a larger group, an Urbania makes the long road journey more comfortable while giving everyone the convenience of travelling together.",
topPlaces: [
{
title: "Shirdi Sai Baba Temple",
description: "The Shri Sai Baba Temple is the main destination for devotees travelling from Pune to Shirdi. An Urbania is suitable for groups visiting the temple together, allowing passengers to coordinate their arrival, darshan schedule, luggage, and return journey comfortably."
},
{
title: "Dwarkamai Shirdi",
description: "Dwarkamai is an important spiritual location associated with Sai Baba and is commonly included in Shirdi pilgrimage plans. Group travellers can conveniently reach this historic site as part of their Pune to Shirdi Urbania itinerary without arranging separate local transportation."
},
{
title: "Chavadi Shirdi",
description: "Chavadi is another significant religious site near the Sai Baba Temple and is frequently visited by devotees during a Shirdi trip. A private Urbania allows families and larger groups to follow their preferred sightseeing and darshan schedule with comfortable transportation."
},
{
title: "Gurusthan Shirdi",
description: "Gurusthan is regarded as one of the important places connected with Sai Baba's early life in Shirdi. Visitors travelling from Pune can include this location in their pilgrimage itinerary while enjoying organized group transportation throughout the journey."
},
{
title: "Khandoba Temple Shirdi",
description: "Khandoba Temple is a notable spiritual attraction associated with the history of Sai Baba's arrival in Shirdi. It can be included in a religious tour itinerary, making an Urbania a practical choice for families and groups planning to visit multiple Shirdi destinations."
},
{
title: "Sai Teerth Devotional Theme Park",
description: "Sai Teerth Devotional Theme Park offers visitors a different way to explore the spiritual heritage and stories associated with Shirdi. Families and group travellers can include the attraction along with temple darshan when planning a comfortable Pune to Shirdi tour."
},
{
title: "Wet N Joy Water Park Shirdi",
description: "Wet N Joy Water Park can be considered by families or mixed-age groups extending their Shirdi visit beyond the pilgrimage schedule. Travelling together in an Urbania provides convenient transportation for groups that want to combine religious activities with family leisure."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is a popular religious destination that can be added to a longer Maharashtra pilgrimage itinerary from Pune. Groups hiring an Urbania can plan Shirdi and Shani Shingnapur together according to their preferred route, halt points, and return schedule."
},
{
title: "Nashik",
description: "Nashik can be incorporated into a broader religious or family road trip when travellers want to cover additional destinations around the Shirdi region. A spacious Urbania makes multi-stop travel easier for larger groups carrying luggage and travelling together."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is an important pilgrimage destination near Nashik and may be included in an extended Maharashtra temple tour. Groups travelling from Pune can combine Shirdi with nearby religious destinations using a dedicated Urbania and a flexible multi-day travel plan."
}
],
services: [
{
name: "Pune to Shirdi Urbania Hire",
description: "Dedicated Urbania hire for Pune to Shirdi journeys, offering group-friendly seating, spacious interiors, luggage capacity, and driver-assisted travel for devotees, families, and organized pilgrimage groups."
},
{
name: "Pune to Shirdi Urbania Booking",
description: "Urbania booking support for planned Shirdi visits with suitable vehicle selection based on group size, travel dates, trip duration, and whether the requirement is one-way, return, or multi-stop travel."
},
{
name: "Pune to Shirdi Urbania Traveller",
description: "Urbania Traveller service for passengers who prefer travelling together from Pune to Shirdi in one comfortable vehicle. It is suitable for family groups, friends, office groups, and devotees travelling for Sai Baba Darshan."
},
{
name: "Pune to Shirdi Urbania Van Rental",
description: "Urbania van rental for Shirdi road trips with practical seating arrangements, comfortable interiors, luggage space, and professional driver support for both short pilgrimage visits and extended tours."
},
{
name: "13 Seater Urbania Pune to Shirdi",
description: "A 13-seater Urbania option for smaller families, friend groups, and pilgrimage parties travelling from Pune to Shirdi. The vehicle provides a convenient private travel setup without requiring the group to split into multiple cars."
},
{
name: "14 Seater Urbania Pune to Shirdi",
description: "The 14-seater Urbania is suitable for medium-sized groups travelling together for Sai Baba Darshan or a family pilgrimage. Its seating capacity helps accommodate passengers and travel belongings while keeping the journey organized."
},
{
name: "17 Seater Urbania Pune to Shirdi",
description: "A 17-seater Urbania provides additional capacity for larger families, religious groups, and friends travelling from Pune to Shirdi. It is useful when the group wants shared transportation with enough room for luggage and a comfortable road journey."
},
{
name: "20 Seater Urbania Pune to Shirdi",
description: "The 20-seater Urbania is designed for larger pilgrimage parties and group tours requiring higher passenger capacity. It allows a sizeable group to travel together while simplifying pickup, route coordination, luggage handling, and return arrangements."
},
{
name: "Luxury Urbania Pune to Shirdi",
description: "Luxury Urbania travel offers a more comfortable road-trip experience for passengers who want spacious seating and a premium travel environment during the Pune to Shirdi journey, especially for family groups and senior travellers."
},
{
name: "Urbania for Shirdi Darshan from Pune",
description: "Urbania transportation for Shirdi Darshan helps devotees travel together from Pune with a planned pickup, comfortable road journey, and convenient return arrangement. The trip can be organized around the group's preferred darshan timing."
},
{
name: "Urbania for Shirdi Family Trip",
description: "A family-focused Urbania option for travelling to Shirdi with children, parents, senior citizens, and relatives. Private group transportation makes it easier to manage luggage, meal breaks, rest stops, and the overall pilgrimage schedule."
},
{
name: "Urbania for Shirdi Group Travel",
description: "Group travel by Urbania is suitable for friends, relatives, devotional groups, and community members who want to stay together throughout the Pune to Shirdi journey instead of arranging multiple smaller vehicles."
},
{
name: "Urbania Rental Pune to Shirdi",
description: "Urbania rental service for Pune to Shirdi provides a dedicated vehicle for the group with flexible trip planning. Customers can select a suitable seating capacity according to passenger count and travel requirements."
},
{
name: "Urbania Outstation Hire Pune to Shirdi",
description: "Outstation Urbania hire for the Pune to Shirdi route is useful for travellers planning a complete intercity pilgrimage. The service can accommodate one-way journeys, return trips, and itineraries involving additional religious destinations."
},
{
name: "Urbania Round Trip Pune to Shirdi",
description: "Round-trip Urbania travel allows groups to travel from Pune to Shirdi and return in the same dedicated vehicle. This option is convenient for planned darshan schedules, family pilgrimages, and groups wanting coordinated pickup and drop-off."
},
{
name: "Urbania Traveller Pune to Shirdi",
description: "Urbania Traveller service provides group transportation for devotees and tourists travelling between Pune and Shirdi. The vehicle can be arranged according to group size, trip duration, and preferred pickup location."
},
{
name: "Urbania for Sai Baba Darshan Pune to Shirdi",
description: "This service is designed for devotees planning Sai Baba Darshan from Pune, with private group transportation that supports convenient pickup, comfortable travel, and return planning around the group's preferred pilgrimage schedule."
},
{
name: "Pune to Shirdi Urbania Tour",
description: "A Pune to Shirdi Urbania tour can be planned for a single-day visit or a longer pilgrimage itinerary. Groups can include temple visits, nearby attractions, meal breaks, and additional destinations depending on the available travel time."
},
{
name: "Pune to Shirdi Urbania Per Km Rate",
description: "Pune to Shirdi Urbania Per Km Rate information helps travellers estimate transportation costs according to distance, vehicle capacity, trip type, and journey requirements. The final fare can depend on the selected Urbania and overall itinerary."
},
{
name: "Affordable Urbania Pune to Shirdi",
description: "Affordable Urbania travel from Pune to Shirdi gives families and groups a practical way to share intercity transportation costs while travelling together. Vehicle selection can be matched with the number of passengers to maintain a comfortable and economical arrangement."
}
],
tableData: [
["Pune to Shirdi Urbania Hire"],
["Pune to Shirdi Urbania Booking"],
["Pune to Shirdi Urbania Traveller"],
["Pune to Shirdi Urbania Van Rental"],
["13 Seater Urbania Pune to Shirdi"],
["14 Seater Urbania Pune to Shirdi"],
["17 Seater Urbania Pune to Shirdi"],
["20 Seater Urbania Pune to Shirdi"],
["Luxury Urbania Pune to Shirdi"],
["Urbania for Shirdi Darshan from Pune"],
["Urbania for Shirdi Family Trip"],
["Urbania for Shirdi Group Travel"],
["Urbania Rental Pune to Shirdi"],
["Urbania Outstation Hire Pune to Shirdi"],
["Urbania Round Trip Pune to Shirdi"],
["Urbania Traveller Pune to Shirdi"],
["Urbania for Sai Baba Darshan Pune to Shirdi"],
["Pune to Shirdi Urbania Tour"],
["Pune to Shirdi Urbania Per Km Rate"],
["Affordable Urbania Pune to Shirdi"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Travel for Long Pilgrimage Journeys",
WhyChoosedescription: "The Pune to Shirdi journey is more comfortable when the entire group can travel together in a spacious Urbania. Comfortable seating, useful luggage space, and an organized private vehicle setup make the road journey convenient for families and devotees."
},
{
WhyChooseheading: "Multiple Seating Capacities",
WhyChoosedescription: "Different Urbania seating options make it easier to select a vehicle according to the actual group size. Smaller families can choose a suitable compact capacity, while larger pilgrimage groups can opt for higher-capacity vehicles without arranging multiple cars."
},
{
WhyChooseheading: "Convenient Sai Baba Darshan Planning",
WhyChoosedescription: "A dedicated vehicle gives the group greater control over its travel schedule for Sai Baba Darshan. Pickup, departure, waiting, local movement, and return arrangements can be planned around the group's preferred pilgrimage timing."
},
{
WhyChooseheading: "Suitable for Families and Senior Citizens",
WhyChoosedescription: "Family pilgrimages often include children, parents, and senior citizens who benefit from a comfortable and coordinated travel arrangement. An Urbania provides shared transportation so the family can stay together throughout the Pune to Shirdi journey."
},
{
WhyChooseheading: "Useful for Round Trips and Extended Tours",
WhyChoosedescription: "Travellers can plan a direct Shirdi visit, a same-day round trip, or a longer Maharashtra pilgrimage covering additional destinations. Flexible itinerary planning makes the Urbania suitable for different travel durations and group requirements."
},
{
WhyChooseheading: "Spacious Arrangement for Group Luggage",
WhyChoosedescription: "Pilgrimage groups may carry bags, personal belongings, food, and other travel items. The spacious Urbania arrangement helps keep passengers and luggage organized during the intercity journey, particularly when the trip includes overnight or multi-stop travel."
},
{
WhyChooseheading: "Experienced Driver Support",
WhyChoosedescription: "Driver-assisted travel helps the group concentrate on its pilgrimage plans instead of managing the entire highway journey. Professional driving support is useful for families and larger groups travelling on the Pune to Shirdi route."
},
{
WhyChooseheading: "Practical Choice for Group Travel",
WhyChoosedescription: "When several passengers are travelling to Shirdi together, one dedicated Urbania can simplify pickup coordination, route planning, and return arrangements. It also keeps the group together and provides a more organized alternative to arranging several separate cars."
}
]
};













const faqData = [
{
question: "How can I hire an Urbania from Pune to Shirdi?",
answer: "Travellers can enquire about an Urbania by sharing their Pune pickup location, Shirdi travel date, passenger count, preferred departure time, and return requirements. Ruturaj Enterprises can plan the vehicle arrangement according to the group's journey schedule and duration."
},
{
question: "Is Urbania suitable for a Pune to Shirdi family trip?",
answer: "An Urbania can be considered when a family group wants to travel together from Pune to Shirdi. It provides a practical group transportation option for temple visits, family tours, religious journeys, and return trips where keeping everyone together is convenient."
},
{
question: "Can I rent an Urbania for a Pune to Shirdi one-day trip?",
answer: "Groups planning a same-day Shirdi visit from Pune can enquire about an Urbania rental based on their preferred departure and return timings. The schedule can be discussed around temple visit plans, meal breaks, local movements, and the expected return journey."
},
{
question: "Can Urbania be used for Shirdi pilgrimage tours from Pune?",
answer: "An Urbania can be arranged for pilgrimage groups travelling from Pune to Shirdi. The itinerary may include Sai Baba temple visits, nearby religious places, accommodation transfers, meal stops, and other planned movements depending on the group's travel schedule."
},
{
question: "Can I hire an Urbania for a Pune to Shirdi group tour?",
answer: "Friends, relatives, social groups, and organized travel parties can enquire about an Urbania for a Pune to Shirdi group journey. A dedicated vehicle allows passengers to travel together while coordinating departure times, stops, temple visits, and the return route more easily."
},
{
question: "Is Urbania available for Pune to Shirdi round trips?",
answer: "A round-trip Urbania arrangement can be discussed for travellers who want transportation from Pune to Shirdi and back. Sharing the departure date, return timing, passenger count, pickup points, and expected duration helps Ruturaj Enterprises understand the complete travel requirement."
},
{
question: "Can senior citizens travel from Pune to Shirdi in an Urbania?",
answer: "Families travelling with senior citizens can enquire about an Urbania for the Pune to Shirdi journey. The group can discuss convenient pickup arrangements, planned breaks, temple timings, local transfers, and the return schedule while organizing transportation for the pilgrimage."
},
{
question: "Can I use an Urbania for Shirdi and nearby sightseeing?",
answer: "Groups visiting Shirdi can discuss an Urbania itinerary that includes nearby religious and sightseeing locations along with the main temple visit. Places such as Shani Shingnapur and other nearby destinations can be included depending on the available time and planned route."
},
{
question: "Can an Urbania be hired for a Pune to Shirdi religious group?",
answer: "Religious groups, community organizations, and extended families can arrange an Urbania for a planned pilgrimage from Pune to Shirdi. The vehicle schedule can be coordinated around the group's preferred departure, temple visit timings, accommodation, meal stops, and return journey."
},
{
question: "What details are required to book a Pune to Shirdi Urbania?",
answer: "Travellers can provide the Pune pickup address, Shirdi destination, journey date, number of passengers, preferred departure time, trip duration, return requirements, and any planned local sightseeing. Ruturaj Enterprises can use these details to discuss the Urbania rental arrangement for the group."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Suresh Jadhav",
feedback:
"Our relatives planned a Shirdi darshan from Pune and included senior family members in the group. We hired an Urbania from Ruturaj Enterprises so everyone could travel together. The vehicle arrangement made it easier to coordinate the departure, temple visit, local movements, and return journey without splitting the group.",
rating: 5
},
{
id: 2,
name: "Miss. Kavita More",
feedback:
"A group of neighbours from Pune arranged a pilgrimage trip to Shirdi with a visit to a nearby religious place. Ruturaj Enterprises provided an Urbania for the journey, and we planned the travel timings in advance. Having one vehicle for the entire group made the trip much simpler to manage.",
rating: 5
}
];








































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Urbania On Rent",
  "image": "https://ruturajenterprises.com/assets/images/pune-to-shirdi-urbania-on-rent.webp",
  "description": "Pune to Shirdi Urbania On Rent from Ruturaj Enterprises is a spacious group travel option for families, devotees, friends and larger groups planning a comfortable journey from Pune to Shirdi. Pune to Shirdi Urbania Hire and Pune to Shirdi Urbania Booking are suitable for planned temple visits, family journeys, group pilgrimages and scheduled outstation travel. Pune to Shirdi Urbania Traveller and Pune to Shirdi Urbania Van Rental provide convenient transportation for passengers travelling together, while 13 Seater Urbania Pune to Shirdi, 14 Seater Urbania Pune to Shirdi, 17 Seater Urbania Pune to Shirdi and 20 Seater Urbania Pune to Shirdi allow groups to select a suitable vehicle according to their passenger count. Luxury Urbania Pune to Shirdi offers a spacious and comfortable option for the journey, particularly for families and groups looking for a premium travel experience. Urbania for Shirdi Darshan from Pune can be arranged for devotees planning temple visits, while Urbania for Shirdi Family Trip and Urbania for Shirdi Group Travel are suitable for families, friends and organized pilgrimage groups. Urbania Rental Pune to Shirdi and Urbania Outstation Hire Pune to Shirdi support planned intercity travel, while Urbania Round Trip Pune to Shirdi is convenient for passengers who need transportation for both the onward and return journey. Urbania Traveller Pune to Shirdi can be arranged according to the group size and itinerary. Urbania for Sai Baba Darshan Pune to Shirdi is suitable for devotees travelling to the Shri Sai Baba temple, while Pune to Shirdi Urbania Tour provides a dedicated group vehicle for the overall trip. Customers checking Pune to Shirdi Urbania Per Km Rate can enquire according to vehicle type, trip duration and route requirements, while Affordable Urbania Pune to Shirdi provides a practical option for groups looking to travel together in one spacious vehicle.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-to-shirdi-urbania-on-rent"
  }
};






    return (
        <div>

<Helmet>
  <title>
    Pune to Shirdi Urbania On Rent | 13, 14, 17 & 20 Seater Traveller for Sai Baba Darshan | +91 9763381382
  </title>

  <meta
    name="description"
    content="Pune to Shirdi Urbania On Rent by Ruturaj Enterprises for Sai Baba Darshan, family trips and group travel with 13, 14, 17 and 20 seater Urbania options."
  />

  <meta
    name="keywords"
    content="Pune to Shirdi Urbania On Rent, Pune to Shirdi Urbania Hire, Pune to Shirdi Urbania Booking, Pune to Shirdi Urbania Traveller, Pune to Shirdi Urbania Van Rental, 13 Seater Urbania Pune to Shirdi, 14 Seater Urbania Pune to Shirdi, 17 Seater Urbania Pune to Shirdi, 20 Seater Urbania Pune to Shirdi, Luxury Urbania Pune to Shirdi, Urbania for Shirdi Darshan from Pune, Urbania for Shirdi Family Trip, Urbania for Shirdi Group Travel, Urbania Rental Pune to Shirdi, Urbania Outstation Hire Pune to Shirdi, Urbania Round Trip Pune to Shirdi, Urbania Traveller Pune to Shirdi, Urbania for Sai Baba Darshan Pune to Shirdi, Pune to Shirdi Urbania Tour, Pune to Shirdi Urbania Per Km Rate, Affordable Urbania Pune to Shirdi, Pune to Shirdi Group Traveller, Pune to Shirdi Family Traveller, Pune to Shirdi Luxury Traveller, Pune Shirdi Outstation Urbania, Pune Shirdi Round Trip Urbania, Shirdi Darshan Traveller from Pune, Sai Baba Darshan Urbania Pune, Shirdi Pilgrimage Urbania Pune, Pune to Shirdi Cab for Group, Urbania with Driver Pune to Shirdi, AC Urbania Pune to Shirdi, Shirdi Tour from Pune Urbania, Pune Shirdi Family Trip Vehicle, Pune Shirdi Group Travel Vehicle, Urbania Rental with Driver Pune, Pune to Shirdi Tour Vehicle"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/113.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdiurbania;